function modifyFeatureLineup() {
  $('.featureLineupContainer').each((i, element) => {
    const title = $(element).find('.featureLineup-title');
    let titleText = title.text().trim();
    if (titleText.length > 45) {
      title.text(`${titleText.substring(0, 45)}...`);
      // add a tooltip to the title with the full text
      title.attr('title', titleText);
      titleText = `${titleText.substring(0, 45)}...`;
    } else {
      title.text(titleText);
    }

    $(element).find('.featureLineup-buynow a.button').addClass('buyNowButton');
    $(element)
      .find('.featureLineup-more .button, .featureLineup-headline')
      .addClass('buttonSmall');
    const description = $(element).find('.featureLineup-text').eq(1);
    const descriptionText = description.text();
    description.empty();
    description.html(
      `<div class="featureLineup-description"><h4>${titleText}</h4> ${descriptionText}</div>`
    );
  });
}

// modify button nav toggle
function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function modifySponsors() {
  const sponsorWidgetContainer = $('#sponsorWidgetContainer');
  const arrows = sponsorWidgetContainer.find('.sponsorArrow');
  arrows.each((i, arrow) => {
    $(arrow).find('span')
      .append(`<svg xmlns="http://www.w3.org/2000/svg" width="22" height="32" viewBox="0 0 22 32">
  <path id="Shape_1_copy" data-name="Shape 1 copy" class="cls-1" d="M1852.01,2710.72l-8.66-8.72,8.66-8.72-6.27-7.28-15.75,16,15.75,15.99Z" transform="translate(-1830 -2686)"/>
</svg>
`);
  });
}
let resized = false;
function fakeGrid() {
  const widgetName = 'activitiesWidget';
  const activitiesItems = $(`#${widgetName} .card-widget-item`);

  if (activitiesItems.length === 6) {
    if (!resized && window.innerWidth >= 1100) {
      $(
        '<div class="card-widget-item white" aria-hidden="true" ></div>'
      ).insertAfter(`#${widgetName} .card-widget-item:nth-child(4)`);
      $(
        '<div class="card-widget-item white" aria-hidden="true" ></div>'
      ).insertAfter(`#${widgetName} .card-widget-item:nth-child(7)`);
      resized = true;
    }
  } else if (activitiesItems.length === 8 && window.innerWidth < 1100) {
    $(`#${widgetName} .card-widget-item.white`).remove();
    resized = false;
  }
}

let headerSpaceResized = false;
function spacingHeader() {
  const spacing = $('header').height() + 30;
  if (!headerSpaceResized && window.innerWidth >= 816) {
    if ($('body').hasClass('homepage')) {
      $('.main-section').css('padding-top', spacing);
    } else {
      $('main.content').css('margin-top', spacing);
    }
    headerSpaceResized = true;
  }
  if (window.innerWidth <= 815) {
    if ($('body').hasClass('homepage')) {
      $('.main-section').css('padding-top', `${spacing + 80}px`);
    } else {
      $('main.content').css('margin-top', `${spacing + 80}px`);
    }
    headerSpaceResized = false;
  }
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  $('.header .ticket')
    .removeClass('ticket')
    .addClass('ticket-btn')
    .text('Buy Tickets');
  modifyFeatureLineup();
  modifyBtnNavToggle();
  spacingHeader();
});

$(window).load(() => {
  // ---
  $('#socialNetworkWidget .socialTabContainer').append(
    '<h3>Skerbeck <b>Social</b></h3>'
  );
  fakeGrid();

  setTimeout(() => {
    modifySponsors();
  }, 2000);
});
$(window).resize(() => {
  fakeGrid();
  spacingHeader();
});

$(document).load(function(){
  $(".saffireMobileSize .quick-links .searchBox").insertBefore( $(".saffireMobileSize .header .mobile-nav-toggle"));
});
$(document).ready(function(){
  $(".saffireMobileSize .quick-links .searchBox").insertBefore( $(".saffireMobileSize .header .mobile-nav-toggle"));
});
$(window).resize(function(){
  $(".saffireMobileSize .quick-links .searchBox").insertBefore( $(".saffireMobileSize .header .mobile-nav-toggle"));
});